import React from 'react';
import { TILE_Z_INDEXES } from '@/pages/company/WorkspaceRoute/components/TileGrid/TileCard/components/StyledComponents';
import AvatarGroupMui from '@mui/material/AvatarGroup';
import AvatarMui from '@mui/material/Avatar';

import Tooltip from '@/components/mui/Tooltip';

import { styled, alpha, useTheme } from '@mui/material/styles';

const AvatarGroup = styled(AvatarGroupMui)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(1),
  left: theme.spacing(1),
  zIndex: TILE_Z_INDEXES.userTagAvatars, // overlap MuiCardActionArea-focusHighlight

  '& .MuiAvatar-root': {
    width: 28,
    height: 28,
    fontSize: theme.typography.pxToRem(14),
  },
}));

const AnimationWrapper = styled('div', {
  label: 'AnimationWrapper',
})(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  borderRadius: '50%',

  '@keyframes pulse-ring': {
    '0%, 100%': {
      transform: 'scale(1)',
      opacity: 0.7,
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 1,
    },
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    background: theme.palette.common.white,
    top: -1,
    left: -1,
    right: -1,
    bottom: -1,
    border: `1px solid ${theme.palette.error.main}`,
    borderRadius: '50%',
    animation: 'pulse-ring 2s ease-in-out infinite',
  },
}));

const UserTagAvatars = ({ tags, max, total, sxProps = {}, animated = false }) => {
  const theme = useTheme();

  const surplusTooltip = tags
    .slice(max - 1)
    .map(({ username }) => username)
    .join(', ');

  return (
    <AvatarGroup
      {...(max && { max })}
      {...(total && { total })}
      sx={{
        ...sxProps,
      }}
      slotProps={{
        img: {
          loading: 'lazy',
        },
        surplus: {
          sx: {
            backgroundColor: alpha(theme.palette.primary.main, 0.2),
            color: theme.palette.primary.main,
          },
        },
      }}
      renderSurplus={(surplus) => <Tooltip t={surplusTooltip}>+{surplus}</Tooltip>}
    >
      {tags.map((tag) => (
        <Tooltip t={tag.tooltip || tag.username} placement="top" key={tag.userId}>
          {animated ? (
            <AnimationWrapper animated={animated}>
              <AvatarMui src={tag.src} imgProps={{ loading: 'lazy' }} />
            </AnimationWrapper>
          ) : (
            <AvatarMui src={tag.src} imgProps={{ loading: 'lazy' }} />
          )}
        </Tooltip>
      ))}
    </AvatarGroup>
  );
};

export default UserTagAvatars;
